export enum ReportCategoryType {
  Fye,
  PensionReport,
  EmployerDetail,
  ReliefReport,
}
